// file created at 2020-1-19
// Auto-generated files AnimationTest.ts

import { Vue, Component } from 'vue-property-decorator';

interface Circle {
  cx: number;
  cy: number;
  pastCx: number;
  pastCy: number;
  r: number;
}

@Component({})
export default class AnimationTest extends Vue {
  private circle: Circle = {
    cx: 100,
    pastCx: 100,
    cy: 100,
    pastCy: 100,
    r: 10
  };

  private moveCircle() {
    console.log('moveCircle');
    this.circle.pastCx = this.circle.cx;
    this.circle.cx += 100;

    // this.circle.pastCy = this.circle.cy;
    // this.circle.cy += 100;
  }

  private mounted() {
    //
  }
}
